import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMachines } from '../context/MachineContext';

export default function ProtectedRoute({ children }) {
  const { isAdmin } = useMachines();
  if (!isAdmin) return <Navigate to="/admin-login" replace />;
  return children;
}
